import * as React from "react";
import { Tooltip } from "antd";

export default {
  render: text => {
    return (
      // 备注信息 过多后隐藏的样式
      <Tooltip title={text}>
        <div className="orderlist-remark">{text}</div>
      </Tooltip>
    );
  }
};
